import { __decorate } from "tslib";
import { EventEmitter, Injectable } from "@angular/core";
import { BehaviorSubject, map } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { AppControllerService } from "../../../app-controller.service";
import { AlertType } from "../../models/alert";
import { ApiWorkflowConstants } from "../../constants/api-constants/api-workflow.constants";
import { ApiNotesConstants } from "../../constants/api-constants/api-notes.constants";
let CurrentStepService = class CurrentStepService {
    http;
    appController;
    getCurrentStepsEvent = new EventEmitter();
    getCurrentStepEvent = new EventEmitter();
    sessionNotes = [];
    currentStepComponent;
    currentStepId = null;
    currentSteps = [];
    currentStep;
    currentNotes;
    autoLoadNextStepSubject = new BehaviorSubject(false);
    $autoLoadNextStep = this.autoLoadNextStepSubject.asObservable();
    showStepSaveSubject = new BehaviorSubject(true);
    $showStepSave = this.showStepSaveSubject.asObservable();
    showStepContinueSubject = new BehaviorSubject(true);
    $showStepContinue = this.showStepContinueSubject.asObservable();
    stepLoadedSubject = new BehaviorSubject(false);
    $stepLoaded = this.stepLoadedSubject.asObservable();
    constructor(http, appController) {
        this.http = http;
        this.appController = appController;
    }
    getCurrentSteps(jobId, moduleId, autoLoadStep = false) {
        return this.http.get(ApiWorkflowConstants.URL + "/" + ApiWorkflowConstants.FUNCTION_JOB_CURRENT_STEPS, {
            params: {
                jobId: jobId?.toString(),
                moduleId: moduleId?.toString()
            }
        }).pipe(map((response) => {
            let jobCurrentSteps = response;
            jobCurrentSteps.forEach(item => {
                item.jobId = +jobId;
                item.moduleId = +moduleId;
            });
            this.currentSteps = jobCurrentSteps;
            this.autoLoadNextStepSubject.next(autoLoadStep);
            this.getCurrentStepsEvent.emit(this.currentSteps);
            return this.currentSteps;
        }));
    }
    setCurrentStep(currentStep) {
        if (this.currentStepId !== undefined && this.currentStepId !== null && this.currentStepId === currentStep.id) {
            return;
        }
        this.currentStepId = currentStep.id;
        try {
            const metadata = JSON.parse(currentStep.stepMeta);
            currentStep.parsedStepMeta = metadata;
        }
        catch (e) {
            this.appController.showMessage("Metadata missing. Please contact your system administrator.", AlertType.Error);
        }
        this.currentStep = currentStep;
        this.getCurrentStepEvent.emit(this.currentStep);
    }
    getMoveToSteps(moduleId, jobId) {
        const params = {
            moduleId,
            jobId
        };
        return this.http.get(ApiWorkflowConstants.URL + "/" + ApiWorkflowConstants.FUNCTION_GET_ALL_MOVABLE_STEP_TYPES, { params });
    }
    setCurrentStepComponent($event) {
        this.currentStepComponent = $event;
    }
    setShowStepSave(disabled) {
        this.showStepSaveSubject.next(disabled);
    }
    setShowStepContinue(disabled) {
        this.showStepContinueSubject.next(disabled);
    }
    setLoadStep(loaded) {
        this.stepLoadedSubject.next(loaded);
    }
    addSessionNoteId(id) {
        this.sessionNotes.push(id);
    }
    getCurrentNotes(jobId) {
        return this.http.get(ApiNotesConstants.URL, {
            params: {
                $expand: `user, step`,
                $filter: `jobId eq ${jobId}`
            }
        }).pipe(map((notes) => {
            this.currentNotes = notes;
            return notes;
        }));
    }
    static ctorParameters = () => [
        { type: HttpClient },
        { type: AppControllerService }
    ];
};
CurrentStepService = __decorate([
    Injectable({
        providedIn: "root"
    })
], CurrentStepService);
export { CurrentStepService };
